function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPay4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10 3)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.12 -0.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1.88, -2.66)",
    d: "M 3.38541 0.758718 C 3.13473 0.586384 2.80761 0.500008 2.40405 0.500008 L 0.841698 0.500008 C 0.717984 0.500008 0.649635 0.561879 0.636652 0.685504 L 0.00199218 4.66943 C -0.00460393 4.70856 0.00518575 4.74434 0.0312717 4.77687 C 0.0572085 4.80947 0.0898309 4.82567 0.1289 4.82567 L 0.871008 4.82567 C 1.00117 4.82567 1.07271 4.76395 1.08584 4.64018 L 1.26158 3.56612 C 1.268 3.51407 1.29089 3.47174 1.32996 3.43915 C 1.369 3.40662 1.41783 3.38534 1.47642 3.37561 C 1.53501 3.36594 1.59025 3.36104 1.64242 3.36104 C 1.69445 3.36104 1.75626 3.36435 1.82798 3.37083 C 1.89952 3.37731 1.94513 3.3805 1.96468 3.3805 C 2.52448 3.3805 2.96389 3.22276 3.28292 2.90693 C 3.6018 2.59127 3.76142 2.15354 3.76142 1.59356 C 3.76142 1.20949 3.63597 0.931231 3.38541 0.758628 L 3.38541 0.758718 Z M 2.57988 1.95497 C 2.54723 2.18285 2.4627 2.3325 2.326 2.40413 C 2.18928 2.47585 1.99399 2.51155 1.74014 2.51155 L 1.41789 2.52128 L 1.58393 1.47644 C 1.59688 1.4049 1.63917 1.36908 1.71083 1.36908 L 1.89642 1.36908 C 2.15668 1.36908 2.34558 1.4066 2.46276 1.48133 C 2.57988 1.55625 2.61895 1.71417 2.57988 1.95497 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 9.19 -0.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,156,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-19.19, -2.66)",
    d: "M 19.8729 0.5 L 19.1504 0.5 C 19.0786 0.5 19.0364 0.535816 19.0235 0.607478 L 18.3888 4.6696 L 18.379 4.68912 C 18.379 4.72183 18.392 4.7526 18.4181 4.78191 C 18.444 4.81116 18.4767 4.82581 18.5157 4.82581 L 19.1603 4.82581 C 19.2837 4.82581 19.3521 4.76409 19.3653 4.64032 L 20 0.646547 L 20 0.636847 C 20 0.545665 19.9575 0.50012 19.8729 0.50012 L 19.8729 0.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.65 0.88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-9.35, -3.88)",
    d: "M 11.1434 2.07225 C 11.1434 2.03977 11.1304 2.00879 11.1045 1.97957 C 11.0784 1.95029 11.0491 1.93555 11.0166 1.93555 L 10.2647 1.93555 C 10.193 1.93555 10.1344 1.96826 10.0889 2.03318 L 9.05385 3.55652 L 8.62421 2.09183 C 8.59149 1.98775 8.51998 1.93555 8.4094 1.93555 L 7.67693 1.93555 C 7.64431 1.93555 7.61503 1.95023 7.58915 1.97957 C 7.56303 2.00879 7.55008 2.03983 7.55008 2.07225 C 7.55008 2.08535 7.61356 2.27732 7.74047 2.64838 C 7.86738 3.01955 8.00408 3.41991 8.15057 3.84958 C 8.29706 4.27916 8.37349 4.50713 8.38003 4.53295 C 7.84619 5.26216 7.57939 5.65273 7.57939 5.70473 C 7.57939 5.78943 7.62162 5.83169 7.70633 5.83169 L 8.4582 5.83169 C 8.52977 5.83169 8.58833 5.79922 8.634 5.73409 L 11.124 2.14057 C 11.137 2.12767 11.1434 2.10499 11.1434 2.07222 L 11.1434 2.07225 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.45 0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,156,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16.45, -3.38)",
    d: "M 18.1448 1.93558 L 17.4027 1.93558 C 17.3114 1.93558 17.2563 2.04303 17.2367 2.2579 C 17.0673 1.99758 16.7583 1.86724 16.309 1.86724 C 15.8403 1.86724 15.4415 2.04303 15.1129 2.39457 C 14.7841 2.7461 14.6198 3.1596 14.6198 3.63476 C 14.6198 4.01892 14.7321 4.32485 14.9566 4.55261 C 15.1812 4.7806 15.4822 4.89438 15.8599 4.89438 C 16.0487 4.89438 16.2407 4.85525 16.436 4.7772 C 16.6313 4.69909 16.7841 4.59499 16.895 4.46474 C 16.895 4.47127 16.8883 4.50046 16.8755 4.55252 C 16.8623 4.60469 16.8559 4.64388 16.8559 4.66969 C 16.8559 4.77398 16.8981 4.82591 16.9829 4.82591 L 17.6567 4.82591 C 17.7802 4.82591 17.8519 4.76419 17.8714 4.64041 L 18.2718 2.0918 C 18.2782 2.0527 18.2685 2.01698 18.2425 1.98438 C 18.2163 1.95191 18.1838 1.93558 18.1448 1.93558 Z M 16.8705 3.85933 C 16.7045 4.02208 16.5043 4.10341 16.27 4.10341 C 16.0811 4.10341 15.9283 4.05142 15.811 3.94719 C 15.6938 3.84327 15.6352 3.70003 15.6352 3.51755 C 15.6352 3.27687 15.7166 3.07325 15.8794 2.90727 C 16.0419 2.74127 16.2439 2.65829 16.4848 2.65829 C 16.6669 2.65829 16.8183 2.71199 16.9388 2.81935 C 17.0592 2.92679 17.1196 3.07489 17.1196 3.26373 C 17.1195 3.49806 17.0365 3.69666 16.8705 3.85933 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.65 0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-5.35, -3.38)",
    d: "M 7.05202 1.93558 L 6.30989 1.93558 C 6.21862 1.93558 6.16341 2.04303 6.14386 2.2579 C 5.96809 1.99758 5.65885 1.86724 5.2162 1.86724 C 4.74749 1.86724 4.34871 2.04303 4.02001 2.39457 C 3.69122 2.7461 3.52692 3.1596 3.52692 3.63476 C 3.52692 4.01892 3.63923 4.32485 3.86382 4.55261 C 4.08842 4.7806 4.38942 4.89438 4.76704 4.89438 C 4.94922 4.89438 5.13812 4.85525 5.33337 4.7772 C 5.52866 4.69909 5.68491 4.59499 5.80208 4.46474 C 5.77597 4.54279 5.76301 4.61117 5.76301 4.66969 C 5.76301 4.77398 5.80531 4.82591 5.88995 4.82591 L 6.56371 4.82591 C 6.6873 4.82591 6.75899 4.76419 6.77854 4.64041 L 7.17887 2.0918 C 7.18529 2.0527 7.17556 2.01698 7.14959 1.98438 C 7.12354 1.95191 7.09103 1.93558 7.05202 1.93558 Z M 5.77773 3.86416 C 5.61169 4.02384 5.40817 4.10341 5.16746 4.10341 C 4.97856 4.10341 4.82721 4.05142 4.71337 3.94719 C 4.59939 3.84327 4.54247 3.70003 4.54247 3.51755 C 4.54247 3.27687 4.6238 3.07325 4.78662 2.90727 C 4.94925 2.74127 5.15107 2.65826 5.39202 2.65826 C 5.57421 2.65826 5.72556 2.71199 5.84611 2.81935 C 5.96645 2.92679 6.02674 3.07489 6.02674 3.26373 C 6.02671 3.5046 5.94374 3.70484 5.77773 3.86416 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.97 -0.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,156,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12.97, -2.66)",
    d: "M 14.4782 0.75871 C 14.2275 0.586376 13.9005 0.5 13.4968 0.5 L 11.9442 0.5 C 11.814 0.5 11.7423 0.561872 11.7294 0.685496 L 11.0947 4.66942 C 11.0881 4.70855 11.0979 4.74433 11.124 4.77687 C 11.1498 4.80946 11.1825 4.82567 11.2216 4.82567 L 12.0223 4.82567 C 12.1004 4.82567 12.1524 4.7834 12.1786 4.69876 L 12.3543 3.56611 C 12.3608 3.51406 12.3836 3.47174 12.4227 3.43914 C 12.4618 3.40661 12.5105 3.38533 12.5692 3.3756 C 12.6277 3.36593 12.683 3.36103 12.7352 3.36103 C 12.7872 3.36103 12.849 3.36435 12.9207 3.37082 C 12.9922 3.3773 13.038 3.38049 13.0574 3.38049 C 13.6173 3.38049 14.0566 3.22275 14.3756 2.90692 C 14.6946 2.59126 14.8541 2.15353 14.8541 1.59355 C 14.8541 1.20948 14.7287 0.931193 14.4782 0.75862 L 14.4782 0.75871 Z M 13.4773 2.36502 C 13.3341 2.46265 13.1192 2.51145 12.8329 2.51145 L 12.5204 2.52124 L 12.6864 1.47637 C 12.6993 1.40486 12.7416 1.36898 12.8133 1.36898 L 12.989 1.36898 C 13.1322 1.36898 13.2461 1.37552 13.3309 1.3885 C 13.4153 1.40158 13.4968 1.4422 13.575 1.51052 C 13.6531 1.57889 13.6921 1.67822 13.6921 1.80835 C 13.6921 2.08187 13.6204 2.26731 13.4773 2.36502 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay4);
export default __webpack_public_path__ + "static/media/pay4.b4531bcaa12f760e13694d4162d33450.svg";
export { ForwardRef as ReactComponent };